import type { FulfillmentAccessResponse } from '~/interfaces/order_status';

export const fetchFulfillmentWithToken = async (
  fulfillmentId: string,
  redemptionToken: string,
  signal?: AbortSignal,
): Promise<FulfillmentAccessResponse> => {
  const formData = new FormData();
  formData.append('fulfillmentId', fulfillmentId);
  formData.append('redemptionToken', redemptionToken);

  const response = await fetch('/access_fulfillment_with_token', {
    method: 'PUT',
    body: formData,
    signal,
    headers: {
      'Sec-Fetch-Dest': 'empty',
    },
  });

  if (!response.ok) {
    throw new Error('Failed to access fulfillment with token');
  }

  return response.json();
};
